import palette from '../theme/fingo/palette';
import { BYTES_PER_MB } from './file-formats';

export const RISK_LIST_TYPES = {
  GREENLIST: 'GREENLIST',
  WATCHLIST: 'WATCHLIST',
  BLACKLIST: 'BLACKLIST',
};

export const RISK_LIST_TYPE_OPTIONS = Object.values(RISK_LIST_TYPES);

export const RISK_LIST_EXCEL_MAX_SIZE_MB = 20;

export const RISK_LIST_EXCEL_MAX_SIZE_BYTES = RISK_LIST_EXCEL_MAX_SIZE_MB * BYTES_PER_MB;

export const RISK_LIST_EXCEL_EXTENSION = '.xlsx';

export const RISK_LIST_EXCEL_ACCEPT = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [RISK_LIST_EXCEL_EXTENSION],
};

export const RISK_LIST_EXCEL_RUT_COLUMN = 'RUT';

export const RISK_LIST_EXCEL_TYPE_COLUMN = 'Tipo lista';

export const RISK_LIST_EXCEL_CATEGORIES_COLUMN = 'Motivo';

export const RISK_LIST_EXCEL_COMMENT_COLUMN = 'Comentario';

export const RISK_LIST_EXCEL_CATEGORIES_SEPARATOR = ';';

export const RISK_LIST_EXCEL_TEMPLATE_COLUMNS = [
  RISK_LIST_EXCEL_RUT_COLUMN,
  RISK_LIST_EXCEL_TYPE_COLUMN,
  RISK_LIST_EXCEL_CATEGORIES_COLUMN,
  RISK_LIST_EXCEL_COMMENT_COLUMN,
];

export const RISK_LIST_EXCEL_TEMPLATE_EXAMPLE = [
  '99.999.999-0',
  'Greenlist',
  'GGPP_MMPP',
  'Ejemplo, eliminar esta fila',
];

export const EMPTY_RISK_LIST_CATEGORIES = [];

export const RISK_LIST_CATEGORIES_LABEL = 'Motivo';

export const RISK_LIST_CATEGORIES_ERROR_MESSAGE = 'No se pudieron cargar los motivos';

export const RISK_LIST_CATEGORIES_PLACEHOLDER = 'Selecciona motivo(s) de incorporación a la lista';

export const RISK_LIST_CATEGORIES_ALL_LABEL = 'Todos';

export const RISK_LIST_INDIVIDUAL_TAB = 'individual';

export const RISK_LIST_MASSIVE_TAB = 'massive';

export const RISK_LIST_ADD_SUCCESS_ALERT = {
  id: 'risk-list-add-success',
  severity: 'success',
  color: 'success',
};

export const RISK_LIST_ADD_SUCCESS_MESSAGES = {
  [RISK_LIST_INDIVIDUAL_TAB]: 'Empresa agregada a la lista de riesgo',
  [RISK_LIST_MASSIVE_TAB]: 'Empresas agregadas a la lista de riesgo',
};

export const RISK_LIST_TEMPLATE_ERROR_ALERT = {
  id: 'risk-list-template-error',
  severity: 'error',
  color: 'error',
  message: 'Error al descargar la plantilla',
};

export const RISK_LIST_DISPLAY = {
  [RISK_LIST_TYPES.BLACKLIST]: {
    label: 'Blacklist',
    color: palette.error.A700,
    bgcolor: palette.error.A200,
  },
  [RISK_LIST_TYPES.WATCHLIST]: {
    label: 'Watchlist',
    color: palette.warning.A800,
    bgcolor: palette.warning.A200,
  },
  [RISK_LIST_TYPES.GREENLIST]: {
    label: 'Greenlist',
    color: palette.success.A800,
    bgcolor: palette.success.A200,
  },
};

export const RESTRICTIVE_RISK_LIST_TYPES = [RISK_LIST_TYPES.BLACKLIST, RISK_LIST_TYPES.WATCHLIST];

const joinRiskListTypeLabels = (types, separator) => types
  .map((type) => RISK_LIST_DISPLAY[type].label)
  .join(separator);

export const RISK_LIST_CATEGORIES_BY_TYPE_GROUP_VARIABLES = {
  restrictiveRiskListType: RISK_LIST_TYPES.BLACKLIST,
  greenlistRiskListType: RISK_LIST_TYPES.GREENLIST,
};

export const RISK_LIST_EXCEL_CATEGORY_CODE_GROUPS = [
  {
    label: joinRiskListTypeLabels(RESTRICTIVE_RISK_LIST_TYPES, ' / '),
    field: 'restrictiveCategories',
  },
  {
    label: RISK_LIST_DISPLAY[RISK_LIST_TYPES.GREENLIST].label,
    field: 'greenlistCategories',
  },
];

const RISK_LIST_EXCEL_RUT_INSTRUCTION = `${RISK_LIST_EXCEL_RUT_COLUMN} → sin repetir en el archivo`;

const RISK_LIST_EXCEL_TYPE_INSTRUCTION = `${RISK_LIST_EXCEL_TYPE_COLUMN} → ${joinRiskListTypeLabels(RISK_LIST_TYPE_OPTIONS, ', ')}`;

const RISK_LIST_EXCEL_COMMENT_INSTRUCTION = `${RISK_LIST_EXCEL_COMMENT_COLUMN} (opcional)`;

export const RISK_LIST_EXCEL_COLUMN_INSTRUCTIONS = [
  RISK_LIST_EXCEL_RUT_INSTRUCTION,
  RISK_LIST_EXCEL_TYPE_INSTRUCTION,
  `${RISK_LIST_EXCEL_CATEGORIES_COLUMN} → códigos separados por ${RISK_LIST_EXCEL_CATEGORIES_SEPARATOR} (opcional)`,
  RISK_LIST_EXCEL_COMMENT_INSTRUCTION,
];

export const RISK_LIST_EXCEL_COLUMN_INSTRUCTIONS_WITHOUT_CATEGORIES = [
  RISK_LIST_EXCEL_RUT_INSTRUCTION,
  RISK_LIST_EXCEL_TYPE_INSTRUCTION,
  `${RISK_LIST_EXCEL_CATEGORIES_COLUMN} → dejar vacío, no hay motivos disponibles`,
  RISK_LIST_EXCEL_COMMENT_INSTRUCTION,
];

export const RISK_LIST_EXCEL_COLUMNS_TITLE = 'El archivo debe incluir las siguientes columnas:';

export const RISK_LIST_EXCEL_CATEGORY_CODES_TITLE = `Códigos de ${RISK_LIST_EXCEL_CATEGORIES_COLUMN} según ${RISK_LIST_EXCEL_TYPE_COLUMN}:`;
